import { FC } from 'react';

export const IconCollapseLeft: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="currentColor"
  >
    <path d="M12.994 1v8H5.408l3.293-3.293-1.414-1.414L1.58 10l5.707 5.707 1.414-1.414L5.408 11h7.586v8h2.001V1h-2Z" />
  </svg>
);
